import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {titleToId} from 'utils/url-rewrite';
import CollapsibleSection from 'modules/Common/components/CollapsibleSection';

require("./InsightDescription.scss");

export default class InsightDescription extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    selectedId: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = { insightId: titleToId(props.type) };
  }

  render() {
    return (
      <div className="insight" id={this.state.insightId}>
        <CollapsibleSection title={this.props.title} collapsed={this.state.insightId !== this.props.selectedId}>
          <p className="insight-description">{this.props.description}</p>
        </CollapsibleSection>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/components/InsightDescription.js